module.exports = __webpack_public_path__ + "static/img/j-2.0aa3792c.png";